$(function() {

	scrollFunction();

	// Side Menu Control
	var myDir = ($("html").attr('dir') == 'rtl' ? 'right' : 'left');
	// var mySlidebars = new $.slidebars();
	// $('.mobile-menu-btn').on('click', function() {
	// 	mySlidebars.slidebars.toggle(myDir);
	// });

	$(window).on("scroll", scrollFunction);
	$(window).on("scroll", scrollFunction2);

	function scrollFunction() {
		if ($(window).scrollTop() > 20) {
			$(".main-header").addClass("scrolling");
		} else {
			$(".main-header").removeClass("scrolling");
		}
	}

	function scrollFunction2() {
		if ($(window).scrollTop() > 100) {
			// $(".contacts-side").addClass("showen");
			// show modal form
			// if ($('#modalForm').attr('data-displayed') === 'false') {
			// 	$('#modalForm').modal('show');
			// 	$('#modalForm').attr('data-displayed', 'true');
			// }
		} else {
			// $(".contacts-side").removeClass("showen");
		}
	}
	// show modal on leave page
	// function UnLoadWindow() {
	// 	$('#modalForm').modal('show');
	// }
	// window.onbeforeunload = UnLoadWindow;

	// menu over class for country menu

	$('.main-navi .c-l-m.country-list-menu .drop-menu__ul > li').hover(
		function() {
			$('.main-navi .c-l-m.country-list-menu .drop-menu__ul > li').each(function() {
				$(this).removeClass('open');
			});
			$(this).addClass('open');
			// for inner drop
			$('.main-navi .c-l-m.country-list-menu .drop-menu__ul li.open .drop-menu_inner > ul > li').hover(
				function() {
					$('.main-navi .c-l-m.country-list-menu .drop-menu__ul li.open .drop-menu_inner > ul > li').each(function() {
						$(this).removeClass('open');
					});
					$(this).addClass('open');
				},
				function() {
					// $(this).removeClass('open');
					// console.log('remove inner open');
				}
			)
		},
		function() {
			$('.main-navi .c-l-m.country-list-menu .drop-menu__ul li.open .drop-menu_inner > ul > li').each(function() {
				$(this).removeClass('open');
			});
			$('.first').each(function() {
				$(this).addClass('open');
			})
		}
	)
	//menu over for other menus
	$('.main-navi .c-l-m:not(".country-list-menu") .drop-menu__ul > li').hover(
		function() {
			$('.main-navi .c-l-m:not(".country-list-menu") .drop-menu__ul > li').each(function() {
				$(this).removeClass('open');
			});
			$(this).addClass('open');
			// for inner drop
			$('.main-navi .c-l-m:not(".country-list-menu") .drop-menu__ul li.open .drop-menu_inner > ul > li').hover(
				function() {
					$('.main-navi .c-l-m:not(".country-list-menu") .drop-menu__ul li.open .drop-menu_inner > ul > li').each(function() {
						$(this).removeClass('open');
					});
					$(this).addClass('open')
				},
				function() {
					// $(this).removeClass('open')
				}
			)
		},
		function() {
			// $(this).removeClass('open')
		}
	)

	// banner menu over class
	// $('.banner-search .drop-menu__ul > li').hover(
	// 	function() {
	// 		$('.banner-search .drop-menu__ul > li').each(function() {
	// 			$(this).removeClass('open');
	// 			console.log('1');
	// 		});
	// 		$(this).addClass('open');
	// 		console.log($(this));

	// 		// if ($(this).hasClass('open')) {
	// 		// 	console.log('has class');
	// 		// 	$(this).removeClass('open');
	// 		// }

	// 		$('.banner-search .drop-menu__ul li.open .drop-menu_inner > ul > li').hover(
	// 			function() {
	// 				$('.banner-search .drop-menu__ul li.open .drop-menu_inner > ul > li').each(function() {
	// 					$(this).removeClass('open');
	// 					console.log('remove');
	// 				});
	// 				$(this).addClass('open');
	// 				console.log('add');
	// 			},
	// 			function() {
	// 				// $(this).removeClass('open')
	// 				console.log('4');

	// 			}
	// 		)
	// 	},
	// 	function() {
	// 		$('.banner-search .drop-menu__ul li.open .drop-menu_inner > ul > li').each(function() {
	// 			$(this).removeClass('open');
	// 			console.log('5');

	// 		});
	// 		$('.first').each(function() {
	// 			$(this).addClass('open');
	// 			console.log('6');
	// 		})
	// 	}
	// 	// for inner drop

	// )

	if ($(window).width() <= 480) {
		$('.banner-search .drop-menu__ul > li').each(function() {
			$(this).on('click', function() {
				if ($(this).hasClass('open')) {
					$(this).removeClass('open');
				} else {
					$('.banner-search .drop-menu__ul > li').each(function() {
						$(this).removeClass('open')
					})
					$(this).addClass('open');
				}
			})
		})
	} else {
		$('.banner-search .drop-menu__ul > li').hover(
			function() {
				$('.banner-search .drop-menu__ul > li').each(function() {
					$(this).removeClass('open');
					console.log('1');
				});
				$(this).addClass('open');
				console.log($(this));

				// if ($(this).hasClass('open')) {
				// 	console.log('has class');
				// 	$(this).removeClass('open');
				// }

				$('.banner-search .drop-menu__ul li.open .drop-menu_inner > ul > li').hover(
					function() {
						$('.banner-search .drop-menu__ul li.open .drop-menu_inner > ul > li').each(function() {
							$(this).removeClass('open');
							console.log('remove');
						});
						$(this).addClass('open');
						console.log('add');
					},
					function() {
						// $(this).removeClass('open')
						console.log('4');

					}
				)
			},
			function() {
				$('.banner-search .drop-menu__ul li.open .drop-menu_inner > ul > li').each(function() {
					$(this).removeClass('open');
					console.log('5');

				});
				$('.first').each(function() {
					$(this).addClass('open');
					console.log('6');
				})
			}
			// for inner drop

		)
	}

});